(function() {
  var dmm = document.getElementById('spDmm');
  if (!dmm) return;
  // The approved desktop navigation now owns its Diamonds panel. Keep this
  // legacy fixed panel available to older header revisions, but never attach
  // it to the new desktop nav or hide that nav's inline panel.
  if (document.querySelector('.spm-nav')) {
    dmm.classList.remove('is-open');
    dmm.setAttribute('aria-hidden', 'true');
    return;
  }
  function findDiamondsLi() {
    var megaLis = document.querySelectorAll('header.mainheader li.megaHover, .mainheader li.megaHover, li.megaHover');
    for (var i = 0; i < megaLis.length; i++) {
      var firstLink = megaLis[i].querySelector('a');
      var linkTxt = firstLink ? (firstLink.textContent || '').trim().toLowerCase() : '';
      if (linkTxt === 'diamonds' || linkTxt === 'diamond') return { li: megaLis[i], link: firstLink };
    }
    var links = document.querySelectorAll('header.mainheader a');
    for (var j = 0; j < links.length; j++) {
      var t = (links[j].textContent || '').trim().toLowerCase();
      if (t === 'diamonds' || t === 'diamond') {
        var el = links[j];
        while (el && el !== document.body) {
          if (el.tagName === 'LI') return { li: el, link: links[j] };
          el = el.parentElement;
        }
      }
    }
    return null;
  }
  var openTimer = null, closeTimer = null;
  var currentLi = null;
  function openMenu(li) {
    clearTimeout(closeTimer);
    currentLi = li;
    // open flush under the nav item itself (was header.bottom, which left a ~22px gap below the nav row)
    var anchor = li || document.querySelector('header.mainheader');
    if (anchor) { dmm.style.top = anchor.getBoundingClientRect().bottom + 'px'; }
    dmm.classList.add('is-open'); dmm.setAttribute('aria-hidden', 'false');
    if (li) li.classList.add('sp-dmm-host-open');
  }
  function closeMenu(li) {
    clearTimeout(openTimer);
    closeTimer = setTimeout(function() {
      dmm.classList.remove('is-open'); dmm.setAttribute('aria-hidden', 'true');
      var target = li || currentLi;
      if (target) target.classList.remove('sp-dmm-host-open');
      currentLi = null;
    }, 150);
  }
  function closeMenuNow() {
    clearTimeout(openTimer); clearTimeout(closeTimer);
    dmm.classList.remove('is-open'); dmm.setAttribute('aria-hidden', 'true');
    if (currentLi) currentLi.classList.remove('sp-dmm-host-open');
    currentLi = null;
  }
  function init() {
    var found = findDiamondsLi();
    if (!found) return;
    var li = found.li, link = found.link;
    li.classList.add('sp-dmm-host');
    li.addEventListener('pointerenter', function() {
      var kids = li.children;
      for (var i = 0; i < kids.length; i++) if (kids[i].tagName !== 'A' && kids[i].tagName !== 'SPAN') kids[i].style.display = 'none';
    });
    li.addEventListener('mouseenter', function() { openTimer = setTimeout(function(){ openMenu(li); }, 60); });
    li.addEventListener('mouseleave', function() { closeMenu(li); });
    dmm.addEventListener('mouseenter', function() { clearTimeout(closeTimer); });
    dmm.addEventListener('mouseleave', function() { closeMenu(li); });
    link.addEventListener('focus', function(){ openMenu(li); });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeMenu(li); });

    var lastY = window.scrollY;
    window.addEventListener('scroll', function() {
      if (!dmm.classList.contains('is-open')) { lastY = window.scrollY; return; }
      if (Math.abs(window.scrollY - lastY) > 8) closeMenuNow();
      lastY = window.scrollY;
    }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
